var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardGame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1570_106485)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.248 20.6495L20.3201 21.9329C21.1441 22.038 21.9038 21.4509 22.0093 20.6303L23.9886 5.17087C24.094 4.35032 23.5054 3.59259 22.6827 3.48745L12.8146 2.22998L10.248 20.6495Z",
    fill: "#DFF6FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3804 4.96614L20.4011 20.4256C20.2957 21.2448 19.5401 21.8305 18.7188 21.7281L20.3189 21.9329C21.143 22.0381 21.9027 21.4509 22.0081 20.6304L23.9875 5.17093C24.0929 4.35039 23.5043 3.59265 22.6816 3.48751L21.0745 3.28271C21.8986 3.38786 22.4859 4.14559 22.3804 4.96614Z",
    fill: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4728 15.7423C15.6151 15.9334 15.8711 15.9662 16.0572 15.8174L19.4575 13.084C21.6504 11.3213 19.1084 7.89441 16.9114 9.66113L16.5076 9.98607L16.1982 9.57099C14.5131 7.30594 11.1882 9.98471 12.8705 12.2443L15.4728 15.7423Z",
    fill: "#FE3D97"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.0896 12.474L14.9316 15.0135L15.4737 15.7425C15.6161 15.9337 15.872 15.9665 16.0582 15.8176L19.4584 13.0843C21.2133 11.6739 19.9362 9.19856 18.2306 9.16992C19.0656 9.99998 19.3093 11.495 18.0896 12.474Z",
    fill: "#E41E7F"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1089 2.05518H1.50848C0.678937 2.05518 0 2.73238 0 3.55977V19.1449C0 19.9723 0.678937 20.6495 1.50848 20.6495H10.2472H12.1089C12.9384 20.6495 13.6174 19.9723 13.6174 19.1449V13.248V8.98007V3.55977C13.6174 2.98635 13.2902 2.48389 12.8138 2.22997C12.603 2.11799 12.3635 2.05518 12.1089 2.05518Z",
    fill: "#DFF6FD"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.1081 2.05518H9.77148C10.0261 2.05518 10.7023 2.11799 10.9131 2.22993C11.3895 2.48389 11.7167 2.9863 11.7167 3.55972V8.98002V13.248V19.1448C11.7167 19.9722 10.6024 20.6494 9.77153 20.6494H10.2465H12.1082C12.9377 20.6494 13.6166 19.9722 13.6166 19.1448V13.248V8.98007V3.55977C13.6166 2.98635 13.2895 2.48389 12.8131 2.22997C12.6023 2.11799 12.3627 2.05518 12.1081 2.05518Z",
    fill: "#C8EFFE"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.08832 7.85232C6.93091 7.68985 6.68725 7.68985 6.53121 7.85232L3.68261 10.811C2.01808 12.5381 4.13158 15.0707 5.91522 14.1314L5.3485 15.9514H8.27102L7.70294 14.1301C9.48518 15.068 11.5987 12.5354 9.93691 10.811L7.08832 7.85232Z",
    fill: "#025F80"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5317 7.85233L5.98828 8.41759L8.69039 11.2219C9.71428 12.2842 9.30366 13.6549 8.41936 14.3294C9.97983 14.4113 11.3788 12.306 9.93741 10.8109L7.08881 7.85228C6.93141 7.68986 6.68775 7.68986 6.5317 7.85233Z",
    fill: "#024C67"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.67953 6.85284L3.46537 3.64434C3.46373 3.63993 3.462 3.63557 3.46012 3.63121C3.39065 3.46729 3.23043 3.36374 3.05334 3.36426C2.87634 3.36599 2.7194 3.47338 2.65354 3.63782C2.65279 3.63965 2.65209 3.64148 2.65139 3.64331L1.42626 6.85181C1.35492 7.03865 1.44857 7.24799 1.63542 7.31934C1.82254 7.39068 2.03165 7.29698 2.103 7.11018L2.31951 6.54309H3.78787L4.00209 7.10915C4.05693 7.25404 4.19465 7.34324 4.34086 7.34324C4.38347 7.34324 4.42678 7.3357 4.46897 7.31971C4.65604 7.24893 4.75031 7.03992 4.67953 6.85284ZM2.59607 5.81878L3.05695 4.6117L3.5137 5.81878H2.59607Z",
    fill: "#024C67"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1570_106485"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardGame);
export default __webpack_public_path__ + "static/media/card-game.cf4e1ba4ec2f226082193bb65bcfdf39.svg";
export { ForwardRef as ReactComponent };